import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-editor" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "spinner",
  "aria-label": "sending"
}
const _hoisted_4 = {
  key: 1,
  src: "/cardpanel_icon/send.svg",
  alt: "send",
  class: "send-icon"
}
const _hoisted_5 = {
  key: 0,
  class: "loading-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      class: "custom-textarea",
      placeholder: "Input rules or describe valid/invalid examples ",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nlText) = $event))
    }, null, 512), [
      [_vModelText, _ctx.nlText]
    ]),
    _createElementVNode("button", {
      class: "send-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSend && _ctx.handleSend(...args))),
      disabled: _ctx.loading || !_ctx.nlText.trim()
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4))
    ], 8, _hoisted_2),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Sending…"))
      : _createCommentVNode("", true)
  ]))
}